<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="11">
        <v-row align="baseline">
          <v-col cols="6" md="3">
            <v-text-field v-model="currFilters.name" :label="$t('ITEM.NAME')" />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.zip"
              :label="$t('PROFILE.ZIP')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.city"
              :label="$t('PROFILE.CITY')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <types-filter
              v-model="currFilters.type"
              item-value="id"
              item-text="name"
              :label="$t('ITEM.TYPE')"
              chips
              multiple
              clearable
              small-chips
              deletable-chips
            />
          </v-col>
        </v-row>
        <v-row class="mt-0" align="baseline">
          <v-col cols="6" md="3">
            <business-customers-filter
              v-model="currFilters.business_customer"
              item-text="name"
              item-value="name"
              :label="$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <concierges-filter
              v-model="currFilters.concierge"
              item-text="full_name"
              item-value="full_name"
              :label="$t('BUILDING_COMPLEXES.CONCIERGE')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <management-companies-filter
              v-model="currFilters.management_company"
              item-text="name"
              item-value="name"
              :label="$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <statuses-filter
              v-model="currFilters.status"
              item-value="id"
              item-text="name"
              :label="$t('ITEM.STATUS')"
              chips
              multiple
              clearable
              small-chips
              deletable-chips
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="1"
        align-self="center"
        class="d-flex flex-wrap justify-md-space-between"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-1 mr-1"
              color="grey"
              depressed
              outlined
              @click="reset"
              v-on="on"
            >
              <v-icon>
                mdi-filter-remove
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
        </v-tooltip>

        <v-btn
          class="mb-1"
          type="submit"
          color="primary"
          depressed
          @click.prevent="setFilters"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import TypesFilter from './filters/TypesFilter';
import StatusesFilter from './filters/StatusesFilter';
import ConciergesFilter from './filters/ConciergesFilter';
import ManagementCompaniesFilter from '@/modules/_global/_components/list_filters/ManagementCompany/ManagementCompaniesSelectFilter.vue';
import { mapState } from 'vuex';
import listFilters from '@/modules/_global/mixins/list-filters';
import BusinessCustomersFilter from '@/modules/_global/_components/list_filters/BusinessCustomer/BusinessCustomersSelectFilter.vue';

export default {
  name: 'BuildingComplexesListFilters',

  components: {
    BusinessCustomersFilter,
    TypesFilter,
    StatusesFilter,
    ConciergesFilter,

    ManagementCompaniesFilter
  },

  mixins: [listFilters],

  data() {
    return {};
  },

  computed: {
    ...mapState('building_complex', ['filters'])
  },

  methods: {
    reset() {
      this.$refs.form.reset();
      this.currFilters = {};
      this.setFilters();
    }
  }
};
</script>
